// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"HeaderWithParent_headerContainer___VF4p","textAboveTitle":"HeaderWithParent_textAboveTitle__HNtSO","header":"HeaderWithParent_header__uTOsq"};